import { Alert } from 'antd';
import { useSyncExternalStore } from 'react';

function subscribe(callback: () => void) {
  window.addEventListener('online', callback);
  window.addEventListener('offline', callback);
  return () => {
    window.removeEventListener('online', callback);
    window.removeEventListener('offline', callback);
  };
}

function onlineSnapshot() {
  return typeof navigator === 'undefined' ? true : navigator.onLine;
}

export function OfflineBanner() {
  const isOnline = useSyncExternalStore(subscribe, onlineSnapshot, () => true);
  if (isOnline) return null;

  return (
    <Alert
      type="warning"
      showIcon
      title="当前处于离线状态，部分能力可能不可用。"
      style={{
        position: 'fixed',
        top: 8,
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 1000,
        maxWidth: 480,
      }}
    />
  );
}
